// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
import VueAnalytics from 'vue-analytics'
import analytics from './plugins/analytics'

sync(store, router)

Vue.use(VueAnalytics, {
  id: process.env.GOOGLE_ANALYTICS_ID
  // debug: {
  //   enabled: true,
  //   trace: false
  // }
})

Vue.use(analytics, { store })

// Import global styles
import './style/main'

// Disable production tips
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js